import React, {
  createContext, useCallback, useContext, useMemo, useState,
} from 'react';
import PropTypes from 'prop-types';

// สถานะเปิด/ปิดของแผงแชท AI ที่เลื่อนออกมาทางซ้าย — อยู่ที่ระดับ root (ไม่ใช่ใน HomeNavbar) เพราะแต่ละ layout
// render HomeNavbar แยกกัน พอเปลี่ยนโมดูลแล้ว component remount สถานะในนั้นจะหายและแชทที่คุยค้างอยู่หลุดทิ้ง
const AiChatPanelContext = createContext({ open: false, toggle: () => {}, close: () => {} });

export const useAiChatPanel = () => useContext(AiChatPanelContext);

export function AiChatPanelProvider({ children }) {
  const [open, setOpen] = useState(false);
  const toggle = useCallback(() => setOpen((prev) => !prev), []);
  const close = useCallback(() => setOpen(false), []);
  const value = useMemo(() => ({ open, toggle, close }), [open, toggle, close]);

  return <AiChatPanelContext.Provider value={value}>{children}</AiChatPanelContext.Provider>;
}

AiChatPanelProvider.propTypes = {
  children: PropTypes.node,
};

export default AiChatPanelContext;
